import * as eventUtils from 'Utilities/EventListener'

const showModalPopUp = (modalLink, HTMLDivElement) => {
  if (modalLink != null && HTMLDivElement != null) {
    modalLink.addEventListener('click', (event) => {
      event.preventDefault()

      HTMLDivElement.classList.add('modal-wrap--visible')
      document.querySelector('.content-container').setAttribute('style', 'overflow-y: hidden;')
    })
  }
}

const modalSelector = (modalLink, HTMLDivElement) => {
  eventUtils.addMultiEventsListener('DOMContentLoaded load page:load turbolinks:load', (event) => {
    showModalPopUp(
      document.querySelector(modalLink),
      document.querySelector(HTMLDivElement)
    )
  })
}

// New Ticket Modal
modalSelector('.js-create-ticket', '.js-react-TicketCreateModal .modal-wrap')
